import React, { ReactElement } from 'react';
import { Desktop } from 'b2b-apps/shop/app/components/App/Header/Desktop';
import { Mobile } from 'b2b-apps/shop/app/components/App/Header/Mobile';
import { isMobile } from 'b2b-apps/shop/common/utils/env';
import { ComponentType, Props } from './';

export const Header: ComponentType = (props: Props): ReactElement => {
  const {
    className,
    deviceType,
    ...restProps
  } = props;

  return (
    <div className={className}>
      {isMobile(deviceType) ? (
        <Mobile {...restProps} />
      ) : (
        <Desktop {...restProps} />
      )}
    </div>
  );
};
